var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8344 13.9316C23.8344 16.4124 22.5561 18.6116 20.5844 19.9983L19.1328 23.1941C18.7969 23.9199 17.8219 24.0608 17.3128 23.4433L15.7094 21.5149C13.6944 21.5149 11.8419 20.8324 10.4336 19.6949L11.0836 18.9258C16.0886 18.5466 20.0428 14.5816 20.0428 9.74994C20.0428 8.92661 19.9236 8.11411 19.7069 7.33411C22.1661 8.63411 23.8344 11.1041 23.8344 13.9316Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6596 6.57579C16.3921 3.97579 13.5646 2.16663 10.293 2.16663C5.80797 2.16663 2.16797 5.55746 2.16797 9.74996C2.16797 12.2308 3.4463 14.43 5.41797 15.8166L6.86964 19.0125C7.20547 19.7383 8.18047 19.8683 8.68964 19.2616L9.28547 18.5466L10.293 17.3333C14.778 17.3333 18.418 13.9425 18.418 9.74996C18.418 8.61246 18.1471 7.53996 17.6596 6.57579ZM13.0013 10.5625H7.58464C7.14047 10.5625 6.77214 10.1941 6.77214 9.74996C6.77214 9.30579 7.14047 8.93746 7.58464 8.93746H13.0013C13.4455 8.93746 13.8138 9.30579 13.8138 9.74996C13.8138 10.1941 13.4455 10.5625 13.0013 10.5625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.f3c875833324decdeccd11805d771eb4.svg";
export { ForwardRef as ReactComponent };